/**
 * defa.collections.Usages
 * A collection of Usage models.
 * @version 1.2.0
 */
import Usage from 'scripts/defa/invoices/model-usage';

const Usages = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: Usage,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default Usages;